import React from "react"
import ReactDOM from 'react-dom/client';
import App from "./App"
import * as serviceWorker from "./serviceWorker"
import { BrowserRouter } from "react-router-dom"
import "./i18n"
import { Provider } from "react-redux"

import store from "./store"

// ─────────────────────────────────────────────────────────────────
// Auto-reload en ChunkLoadError
// ─────────────────────────────────────────────────────────────────
// Cuando se publica un deploy nuevo, los `static/js/*.chunk.js` viejos
// dejan de existir en el CDN. Si el usuario tenía la pestaña abierta y
// navega a una pantalla que requiere uno de esos chunks, webpack
// dispara ChunkLoadError → pantalla blanca.
// Acá interceptamos ese error y forzamos un reload silencioso.
// Usamos sessionStorage para evitar loops si el reload no resuelve nada.
const isChunkLoadError = (msg) => {
  const s = String(msg || "")
  return s.includes("ChunkLoadError")
    || s.includes("Loading chunk")
    || s.includes("Loading CSS chunk")
    || /Failed to fetch dynamically imported module/.test(s)
}

const handleChunkError = () => {
  const KEY = "__chunkReloadAt"
  const last = Number(sessionStorage.getItem(KEY) || 0)
  // No reintentar si ya recargamos en los últimos 10s (evita loop)
  if (Date.now() - last < 10000) return
  sessionStorage.setItem(KEY, String(Date.now()))
  // eslint-disable-next-line no-console
  console.warn("ChunkLoadError detectado — recargando para obtener la versión nueva.")
  window.location.reload()
}

window.addEventListener("error", (event) => {
  if (isChunkLoadError(event?.message) || isChunkLoadError(event?.error?.message)) {
    handleChunkError()
  }
})

window.addEventListener("unhandledrejection", (event) => {
  const reason = event?.reason
  if (isChunkLoadError(reason) || isChunkLoadError(reason?.message)) {
    handleChunkError()
  }
})

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
      <>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <App />
      </BrowserRouter>
  </>
    </Provider>
);

serviceWorker.unregister()
